import React, {FC, useMemo, useState} from 'react';

import {InboxModel} from '../../../../../libs/shared/core/src/models/api/inboxModel';
import {useFetchInboxes} from '../../../../settings/fetchers/inboxes';
import {SearchInboxDropdown, SearchInboxDropdownProps} from './searchInboxDropdown';

/*
 * Props.
 */

interface SearchInboxDropdownContainerProps
  extends Omit<
    SearchInboxDropdownProps,
    'inboxes' | 'onLoadMore' | 'asyncMoreStatus' | 'query' | 'onSetQuery'
  > {
  namespace?: string;
  shouldShowInboxPredicate?: (inbox: InboxModel) => boolean;
}

/*
 * Component.
 */

export const SearchInboxDropdownContainer: FC<SearchInboxDropdownContainerProps> = (props) => {
  const {namespace, shouldShowInboxPredicate, ...childProps} = props;

  const [query, setQuery] = useState('');
  const {inboxes: allInboxes, loadMore, moreStatus} = useFetchInboxes(query, {namespace});

  const inboxes = useMemo(() => {
    if (shouldShowInboxPredicate) {
      return allInboxes.filter(shouldShowInboxPredicate);
    }

    return allInboxes;
  }, [allInboxes, shouldShowInboxPredicate]);

  return (
    <SearchInboxDropdown
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...childProps}
      inboxes={inboxes}
      query={query}
      onSetQuery={setQuery}
      asyncMoreStatus={moreStatus}
      onLoadMore={loadMore}
    />
  );
};
